import { api } from './config';

interface LoginResponse {
  apiKey: string;
}

export async function login(username: string, password: string): Promise<string> {
  try {
    const response = await api.post<LoginResponse>('/api/auth/login', {
      username,
      password,
    });
    
    // Store token in localStorage
    localStorage.setItem('auth_token', response.data.apiKey);
    return response.data.apiKey;
  } catch (error) {
    throw new Error('Invalid credentials');
  }
}

export function logout(): void {
  localStorage.removeItem('auth_token');
}

export function getAuthToken(): string | null {
  return localStorage.getItem('auth_token');
}